
export const locale = {
  "CRD Logistic": "CRD Logistic",
};
